<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-form-group
          :label="$lang.book_title"
          label-for="name"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.book_title"
            :rules="$v.name.$params"
          />
          <b-form-input
            type="text"
            v-model="$v.name.$model"
            :autocomplete="$lang.book_title"
            :state="$v.name.$dirty ? !$v.name.$error : null"
          ></b-form-input>
          <b-form-invalid-feedback
            :style="{ display: $v.name.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.book_title)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.publisher"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.publisher"
            :rules="$v.location_selected.$params"
          />
          <selectAsync
            :options="location_options"
            v-model="$v.location_selected.$model"
            label="caption"
            :asyncFind="getLocation"
            :isValid="
              $v.location_selected.$dirty ? !$v.location_selected.$error : null
            "
            :loading="locationLoading"
            :placeholder="$lang.search_city"
          />
          <b-form-invalid-feedback
            :style="{ display: $v.location_selected.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.publisher)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.title_personality"
          label-for="place_name"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            :showInfo="true"
            :titleText="$lang.title_personality_tooltip"
            slot="label"
            :label="$lang.title_personality"
            :rules="$v.place_name.$params"
          />
          <b-form-input
            type="text"
            v-model="$v.place_name.$model"
            :autocomplete="$lang.book_title"
            :state="$v.place_name.$dirty ? !$v.place_name.$error : null"
          ></b-form-input>
          <b-form-invalid-feedback
            :style="{ display: $v.place_name.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.title_personality)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.Year_publication"
          label-for="year"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.Year_publication"
            :rules="$v.year.$params"
          />
          <date-picker
            v-model="$v.year.$model"
            :state="$v.year.$dirty ? !$v.year.$error : null"
            type="year"
            inputReq="true"
            auto-submit
            clearable
            simple
            :max="new Date() | moment('jYYYY')"
            :class="
              $v.year.$dirty
                ? $v.year.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :style="{ display: $v.year.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.Year_publication)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.description"
          label-for="description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.description"
            :rules="$v.description.$params"
          />
          <b-form-textarea
            class="min-heghit"
            :state="$v.description.$dirty ? !$v.description.$error : null"
            v-model="$v.description.$model"
            type="text"
            :autocomplete="$lang.description"
            :rows="$config.form.textareaRows"
          ></b-form-textarea>
          <b-form-invalid-feedback id="description-feedback"
            >{{ $lang.error_required | replace($lang.description) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <div slot="footer" class="form-group form-btn mt-1">
          <b-button type="submit" size="md" variant="success" @click="save">
            <i class="fa fa-check"></i>
            {{ $lang.submitButton }}
          </b-button>
          <b-button @click="cancel" class="ml-2" size="md" variant="danger">
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  validations: {
    location_selected: { required },
    name: { required },
    place_name: {
      required,
    },
    year: {},
    description: {},
  },
  data() {
    return {
      location_options: [],
      locationLoading: false,
      places: [],
      location_selected: null,
      name: null,
      place_name: null,
      from_year: null,
      year: null,
      description: null,
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    showDelete: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: () => {},
    },
    item_key: {
      type: [String, Number],
    },
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      let payload = {
        location_id: this.location_selected && this.location_selected.id,
        name: this.name,
        place_name: this.place_name,
        year: this.year,
        description: this.description,
      };
      this.$emit("submit", payload);
    },
    cancel() {
      this.$emit("cancel");
    },
    async getLocation(query) {
      if (!query || query.length < 2) {
        this.place_birth_options = [];
        return;
      }
      try {
        let url =
          this.$config.api_url +
          this.$config.resources.location +
          `?city=${query}`;
        const response = await this.$httpService.get(url);
        let locations = response.data.data;
        this.location_options = locations;
      } catch (error) {
        this.$generateError(error);
        this.location_options = [];
      }
    },

    fetchData() {
      this.location_selected = {
        id: this.item.location && this.item.location.id,
        caption: this.item.location && this.item.location.full_path,
      };
      this.description = this.item.description;
      this.name = this.item.name;
      this.place_name = this.item.place_name;
      this.year = this.item.year && this.item.year.toString();
    },
  },
  watch: {
    item(newValue) {
      if (newValue) {
        this.fetchData();
      }
    },
  },
};
</script>
